export default __webpack_public_path__ + "media/flags/cv-045e4bb2.svg";